import { FormControlLabel, Radio } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FormRadioGroup } from "../../../../../../components/fields";
import { VehicleType } from "../../../../../../types";
import { IFormValues } from "../../../../types";
import { editPendingBookingRce } from "../../../../recoil";
import { useRecoilValue } from "recoil";

const FormVehicleCategory = () => {

    const { t } = useTranslation('booking');

    const isPendingBookingRce = useRecoilValue<boolean | undefined>(editPendingBookingRce);

    return (
        <FormRadioGroup<IFormValues>
            name="basicDetails.vehicleCategory"
            label={t('label.vehicleType')}
        >
            <FormControlLabel
                value={VehicleType.CAR}
                label={t('label.car')}
                control={<Radio disabled={isPendingBookingRce}/>}
            />
            <FormControlLabel
                value={VehicleType.VAN}
                label={t('label.van')}
                control={<Radio disabled={isPendingBookingRce}/>}
            />
        </FormRadioGroup >
    )
};

export default FormVehicleCategory;
